(function () {
  'use strict';

  var CABAUSPACE_API_BASE_URL = 'https://be-cabauspace.fly.dev';
  var BUNDLES_FILLER_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0519/9020/0519/files/4caba087-e732-49cf-aeee-2e240e708386_1.png?v=1781085951';

  // StikkySDK moet expliciet geïnitialiseerd worden voordat window.StikkySDK.actions.* beschikbaar is
  // (zelfde aanpak als cabauspace-home.js - zonder deze call blijven .actions/.events/.variables leeg).
  document.addEventListener('DOMContentLoaded', function () {
    try {
      new window.StikkySDK().initialize();
    } catch (e) {
      console.warn('StikkySDK.initialize() failed:', e);
    }
  });

  var escapeHtml = function (str) {
    if (str === null || str === undefined) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  var formatPrice = function (price) {
    var num = Number(price);
    if (isNaN(num)) return '';
    return num.toFixed(2).replace('.', ',');
  };

  var STAR_FILLED_SVG = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.9L22 9.6l-5.5 4.8L18.2 22 12 18.1 5.8 22l1.7-7.6L2 9.6l7.1-0.7L12 2z"/></svg>';

  var renderRatingHtml = function (product) {
    if (product.ratingValue == null) return '';
    var countHtml = product.ratingCount != null
      ? '<span class="bundle-rating-count">(' + product.ratingCount + ')</span>'
      : '';
    return '<div class="bundle-product-rating"><span class="bundle-stars">' + STAR_FILLED_SVG + '</span>' +
      '<span class="bundle-rating-value">' + escapeHtml(String(product.ratingValue)) + '</span>' + countHtml + '</div>';
  };

  var renderChecksHtml = function (product) {
    if (!Array.isArray(product.uspBullets) || !product.uspBullets.length) return '';
    return '<ul class="bundle-product-checks">' +
      product.uspBullets.map(function (line) {
        return '<li>' + escapeHtml(line) + '</li>';
      }).join('') +
      '</ul>';
  };

  // ===== CART OVERLAY =====
  var ensureCartOverlay = function () {
    if (document.getElementById('cabauspace-bundle-cart-overlay')) return;
    var overlay = document.createElement('div');
    overlay.id = 'cabauspace-bundle-cart-overlay';
    overlay.innerHTML =
      '<div class="bundle-cart-overlay-content">' +
      '<div class="bundle-cart-spinner"></div>' +
      '<p class="bundle-cart-overlay-text">De producten worden aan uw winkelwagen toegevoegd.</p>' +
      '</div>';
    document.body.appendChild(overlay);
  };
  var showCartOverlay = function () {
    ensureCartOverlay();
    var overlay = document.getElementById('cabauspace-bundle-cart-overlay');
    if (overlay) overlay.style.display = 'flex';
  };
  var hideCartOverlay = function () {
    var overlay = document.getElementById('cabauspace-bundle-cart-overlay');
    if (overlay) overlay.style.display = 'none';
  };

  // ===== APPLY DISCOUNT CODE (mirrors the dashboard's applyDiscountToCart) =====
  var applyDiscountToCart = function (discountCode) {
    return new Promise(function (resolve) {
      var afterStikky = function () {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.onload = function () {
          iframe.remove();
          if (window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.fetchCart) {
            window.Rebuy.Cart.fetchCart();
          }
          resolve(true);
        };
        iframe.onerror = function () {
          iframe.remove();
          resolve(false);
        };
        iframe.src = '/discount/' + discountCode + '?redirect=/';
        document.body.appendChild(iframe);
        setTimeout(function () {
          if (iframe.parentNode) {
            iframe.remove();
            resolve(true);
          }
        }, 3000);
      };

      if (window.StikkySDK && window.StikkySDK.actions && window.StikkySDK.actions.applyDiscount) {
        window.StikkySDK.actions
          .applyDiscount({ code: discountCode, discountCode: discountCode })
          .then(afterStikky)
          .catch(afterStikky);
      } else {
        afterStikky();
      }
    });
  };

  // ===== ADD ITEMS TO CART =====
  var addItemsToCart = function (items) {
    if (window.StikkySDK && window.StikkySDK.actions && window.StikkySDK.actions.addItemsToCart) {
      var stikkyItems = items.map(function (item) {
        return {
          variantId: String(item.variantId),
          quantity: item.quantity || 1,
          productId: item.productId ? String(item.productId) : undefined
        };
      });
      return window.StikkySDK.actions
        .addItemsToCart({ items: stikkyItems })
        .then(function (result) {
          var success = false;
          result.fold(
            function () { success = false; },
            function () { success = true; }
          );
          if (success) return true;
          return fallbackAddToCart(items);
        })
        .catch(function () {
          return fallbackAddToCart(items);
        });
    }
    return fallbackAddToCart(items);
  };

  var fallbackAddToCart = function (items) {
    if (window.Rebuy && window.Rebuy.Cart) {
      items.forEach(function (item) {
        window.Rebuy.Cart.addItem({ id: Number(item.variantId), quantity: item.quantity || 1 }, { open_cart: true });
      });
      return Promise.resolve(true);
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: items.map(function (i) {
          return { id: i.variantId, quantity: i.quantity || 1 };
        })
      })
    }).then(function () { return true; });
  };

  // ===== PRODUCT CARD RENDERING =====
  var resolveProductImages = function (product, defaultVariantId) {
    var images = Array.isArray(product.images) ? product.images : [];
    var mainImage = null;
    var hoverImage = null;
    if (defaultVariantId && images.length > 0) {
      var matchedImage = images.find(function (img) {
        return Array.isArray(img.variantIds) && img.variantIds.some(function (id) {
          return String(id) === String(defaultVariantId);
        });
      });
      if (matchedImage) {
        mainImage = matchedImage.src;
        var otherImages = images.filter(function (img) { return img !== matchedImage; });
        hoverImage = otherImages.length > 0 ? otherImages[0].src : null;
      }
    }
    if (!mainImage && images.length > 0) {
      mainImage = images[0].src;
      hoverImage = images[1] ? images[1].src : null;
    }
    return { mainImage: mainImage, hoverImage: hoverImage };
  };

  var renderProductCard = function (product, bundleIndex, hideVariantSelector, opts) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var firstVariant = variants[0] || null;
    var defaultVariantId = firstVariant ? firstVariant.id : null;
    var resolvedImages = resolveProductImages(product, defaultVariantId);
    var mainImage = resolvedImages.mainImage;
    var hoverImage = resolvedImages.hoverImage;

    var hasChoice = variants.length > 1;
    var singleVariantFlavor = !hasChoice && firstVariant && firstVariant.title && firstVariant.title !== 'Default Title'
      ? firstVariant.title
      : null;
    var variantSelectHtml = hideVariantSelector
      ? ''
      : (hasChoice
        ? '<div class="bundle-variant-select-wrap"><select class="bundle-variant-select">' +
          variants.map(function (v) {
            return '<option value="' + v.id + '">' + escapeHtml(v.title) + '</option>';
          }).join('') +
          '</select></div>'
        : (singleVariantFlavor
          ? '<div class="bundle-variant-select-wrap"><div class="bundle-variant-label">' + escapeHtml(singleVariantFlavor) + '</div></div>'
          : ''));

    // De hoofdproduct-teaser-tegel is puur ter weergave (zie renderMainProductCard): die is nooit
    // zelf koopbaar, dus mag nooit "uitverkocht" tonen en toont altijd de bundelprijs, ongeacht
    // of het onderliggende Shopify-product varianten/voorraad heeft.
    var price = (opts && opts.priceOverride != null) ? opts.priceOverride : (firstVariant ? firstVariant.price : null);
    var soldOut = (opts && opts.forceAvailable) ? false : variants.length === 0;
    var bundleIndexAttr = bundleIndex != null ? ' data-bundle-index="' + bundleIndex + '"' : '';

    var swapControlHtml = '';
    if (opts && opts.hasAlternatives) {
      swapControlHtml = opts.isSwapped
        ? '<button type="button" class="bundle-product-back">' + BACK_ARROW_SVG + '<span>Terug naar ' + escapeHtml(opts.backToTitle || '') + '</span></button>'
        : '<button type="button" class="bundle-swap-toggle">' + SWAP_ICON_SVG + '<span>Wissel</span></button>';
    }

    return (
      '<article class="bundle-product-card' + (soldOut ? ' bundle-product-sold-out' : '') + '" data-default-variant-id="' + (defaultVariantId || '') + '" data-product-id="' + (product.id || '') + '" data-product-handle="' + (product.handle || '') + '"' + bundleIndexAttr + '>' +
        '<div class="bundle-product-image-wrap">' +
          (mainImage ? '<img src="' + mainImage + '" alt="' + escapeHtml(product.title) + '" class="bundle-product-image bundle-img-primary" />' : '') +
          (hoverImage ? '<img src="' + hoverImage + '" alt="' + escapeHtml(product.title) + '" class="bundle-product-image bundle-img-secondary" />' : '') +
          (soldOut ? '<span class="bundle-sold-out-badge">Uitverkocht</span>' : '') +
        '</div>' +
        '<div class="bundle-product-info">' +
          renderRatingHtml(product) +
          '<h3 class="bundle-product-title">' + escapeHtml(product.title).toUpperCase() + '</h3>' +
          variantSelectHtml +
          renderChecksHtml(product) +
          (price ? '<div class="bundle-product-price">&euro; ' + formatPrice(price) + '</div>' : '') +
          swapControlHtml +
        '</div>' +
      '</article>'
    );
  };

  // ===== SWAP TO ALTERNATIVE PRODUCT =====
  var renderSwapPicker = function (defaultProduct, slotIndex) {
    var alternatives = Array.isArray(defaultProduct.alternatives) ? defaultProduct.alternatives : [];
    if (!alternatives.length) return '';

    var optionsHtml = alternatives.map(function (alt, altIndex) {
      var image = Array.isArray(alt.images) && alt.images[0] ? alt.images[0].src : null;
      return (
        '<button type="button" class="bundle-swap-option" data-alt-index="' + altIndex + '">' +
          (image ? '<img src="' + image + '" alt="' + escapeHtml(alt.title) + '" />' : '') +
          '<span class="bundle-swap-option-title">' + escapeHtml(alt.title) + '</span>' +
        '</button>'
      );
    }).join('');

    return '<div class="bundle-swap-panel" data-slot-index="' + slotIndex + '" style="display:none">' + optionsHtml + '</div>';
  };

  var renderProductSlot = function (product, slotIndex) {
    var hasAlternatives = Array.isArray(product.alternatives) && product.alternatives.length > 0;
    return (
      '<div class="bundle-product-slot" data-slot-index="' + slotIndex + '">' +
        renderProductCard(product, null, false, { hasAlternatives: hasAlternatives, isSwapped: false }) +
        renderSwapPicker(product, slotIndex) +
      '</div>'
    );
  };

  var swapProductSlot = function (bundles, bundleIndex, slotIndex, altIndex) {
    var bundle = bundles[bundleIndex];
    if (!bundle) return;
    var defaultProduct = bundle.products[slotIndex];
    if (!defaultProduct) return;
    var activeProduct = altIndex == null ? defaultProduct : defaultProduct.alternatives[altIndex];
    if (!activeProduct) return;

    var slotEl = document.querySelector(
      '.bundle-section[data-bundle-index="' + bundleIndex + '"] .bundle-product-slot[data-slot-index="' + slotIndex + '"]'
    );
    if (!slotEl) return;

    var hasAlternatives = Array.isArray(defaultProduct.alternatives) && defaultProduct.alternatives.length > 0;
    var articleEl = slotEl.querySelector('.bundle-product-card');
    if (articleEl) {
      articleEl.outerHTML = renderProductCard(activeProduct, null, false, { hasAlternatives: hasAlternatives, isSwapped: altIndex != null, backToTitle: defaultProduct.title });
    }

    if (altIndex == null) {
      delete slotEl.dataset.activeAltIndex;
    } else {
      slotEl.dataset.activeAltIndex = String(altIndex);
    }

    var panelEl = slotEl.querySelector('.bundle-swap-panel');
    if (panelEl) panelEl.style.display = 'none';

    attachVariantImageSwap();
    updateBundleFooterPricing(bundles, bundleIndex);
  };

  var attachSwapHandlers = function (bundles, container) {
    if (container.dataset.swapListenerAttached) return;
    container.dataset.swapListenerAttached = 'true';

    container.addEventListener('click', function (event) {
      var section = event.target.closest('.bundle-section');
      var slot = event.target.closest('.bundle-product-slot');
      if (!section || !slot) return;
      var bundleIndex = parseInt(section.dataset.bundleIndex, 10);
      var slotIndex = parseInt(slot.dataset.slotIndex, 10);

      var toggleBtn = event.target.closest('.bundle-swap-toggle');
      if (toggleBtn) {
        var panel = slot.querySelector('.bundle-swap-panel');
        if (panel) panel.style.display = panel.style.display === 'none' ? '' : 'none';
        return;
      }

      var backBtn = event.target.closest('.bundle-product-back');
      if (backBtn) {
        swapProductSlot(bundles, bundleIndex, slotIndex, null);
        return;
      }

      var optionBtn = event.target.closest('.bundle-swap-option');
      if (optionBtn) {
        swapProductSlot(bundles, bundleIndex, slotIndex, parseInt(optionBtn.dataset.altIndex, 10));
      }
    });
  };

  // ===== BUNDLE SECTION RENDERING =====
  var renderPricingHtml = function (fromPrice, toPrice) {
    return (
      (fromPrice != null ? '<span class="bundle-price-from">&euro; ' + formatPrice(fromPrice) + '</span>' : '') +
      (toPrice != null ? '<span class="bundle-price-to">&euro; ' + formatPrice(toPrice) + '</span>' : '')
    );
  };

  var renderBundle = function (bundle, index) {
    var products = Array.isArray(bundle.products) ? bundle.products : [];
    var productsHtml = products.map(function (product, slotIndex) { return renderProductSlot(product, slotIndex); }).join('');
    var available = bundle.available !== false;

    return (
      '<section class="bundle-section" data-bundle-index="' + index + '">' +
        '<h2 class="bundle-title">' + escapeHtml(bundle.name || '') + '</h2>' +
        (bundle.description ? '<p class="bundle-description">' + escapeHtml(bundle.description) + '</p>' : '') +
        '<div class="bundle-products-carousel">' + productsHtml + '</div>' +
        '<div class="bundle-footer">' +
          '<div class="bundle-pricing">' + renderPricingHtml(bundle.fromPrice, bundle.toPrice) + '</div>' +
          '<button type="button" class="bundle-add-button" data-bundle-index="' + index + '"' + (available ? '' : ' disabled') + '>' +
            (available ? 'Voeg toe aan winkelwagen' : 'Niet beschikbaar') +
          '</button>' +
          (!available && bundle.unavailableReason ? '<p class="bundle-unavailable-reason">' + escapeHtml(bundle.unavailableReason) + '</p>' : '') +
        '</div>' +
      '</section>'
    );
  };

  // ===== EFFECTIEVE PRIJS/KORTINGSCODE (bundel-niveau, tenzij een actief alternatief een override meegeeft) =====
  var getActiveOverride = function (bundle, section) {
    var activeSlot = section.querySelector('.bundle-product-slot[data-active-alt-index]');
    if (!activeSlot) return null;
    var slotIndex = parseInt(activeSlot.dataset.slotIndex, 10);
    var altIndex = parseInt(activeSlot.dataset.activeAltIndex, 10);
    var defaultProduct = bundle.products[slotIndex];
    var alternative = defaultProduct && Array.isArray(defaultProduct.alternatives) ? defaultProduct.alternatives[altIndex] : null;
    return alternative || null;
  };

  var getEffectivePricing = function (bundle, bundleIndex) {
    var section = document.querySelector('.bundle-section[data-bundle-index="' + bundleIndex + '"]');
    var override = section ? getActiveOverride(bundle, section) : null;
    return {
      fromPrice: (override && override.fromPrice != null) ? override.fromPrice : bundle.fromPrice,
      toPrice: (override && override.toPrice != null) ? override.toPrice : bundle.toPrice,
      discountCode: (override && override.discountCode) ? override.discountCode : bundle.discountCode
    };
  };

  var updateBundleFooterPricing = function (bundles, bundleIndex) {
    var bundle = bundles[bundleIndex];
    if (!bundle) return;
    var section = document.querySelector('.bundle-section[data-bundle-index="' + bundleIndex + '"]');
    if (!section) return;
    var pricingEl = section.querySelector('.bundle-pricing');
    if (!pricingEl) return;
    var pricing = getEffectivePricing(bundle, bundleIndex);
    pricingEl.innerHTML = renderPricingHtml(pricing.fromPrice, pricing.toPrice);
  };

  // ===== MAIN PRODUCT CAROUSEL (initial overview) =====
  // Elke bundel wordt hier vertegenwoordigd door zijn hoofdproduct, gerenderd als een
  // exact gewone product-tegel (zelfde stijl/gedrag als binnen een uitgeklapte bundel).
  var renderMainProductCard = function (bundle, index) {
    if (!bundle.mainProduct) return '';
    var teaserPrice = bundle.toPrice != null ? bundle.toPrice : bundle.fromPrice;
    return renderProductCard(bundle.mainProduct, index, true, { forceAvailable: true, priceOverride: teaserPrice });
  };

  var BACK_ARROW_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg>';
  var SWAP_ICON_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>';

  var showBundleOverview = function () {
    var carousel = document.getElementById('cabauspace-bundle-main-products-carousel');
    var detailContainer = document.getElementById('cabauspace-bundle-detail-container');
    var fillerImg = document.getElementById('cabauspace-bundles-filler-image');
    if (detailContainer) detailContainer.innerHTML = '';
    if (carousel) carousel.style.display = '';
    if (fillerImg) fillerImg.style.display = '';
  };

  var showBundleDetail = function (bundles, index) {
    var carousel = document.getElementById('cabauspace-bundle-main-products-carousel');
    var detailContainer = document.getElementById('cabauspace-bundle-detail-container');
    var fillerImg = document.getElementById('cabauspace-bundles-filler-image');
    if (!carousel || !detailContainer) return;

    carousel.style.display = 'none';
    if (fillerImg) fillerImg.style.display = 'none';
    detailContainer.innerHTML =
      '<button type="button" class="bundle-back-button">' + BACK_ARROW_SVG + '<span>Terug</span></button>' +
      renderBundle(bundles[index], index);

    var backBtn = detailContainer.querySelector('.bundle-back-button');
    if (backBtn) backBtn.addEventListener('click', showBundleOverview);

    attachVariantImageSwap();
    attachAddToCartButtons(bundles);
    attachSwapHandlers(bundles, detailContainer);
    detailContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  var attachMainProductClickHandlers = function (bundles) {
    var carousel = document.getElementById('cabauspace-bundle-main-products-carousel');
    if (!carousel) return;

    carousel.addEventListener('click', function (event) {
      var card = event.target.closest('.bundle-product-card');
      if (!card || card.dataset.bundleIndex == null) return;
      showBundleDetail(bundles, parseInt(card.dataset.bundleIndex, 10));
    });
  };

  // ===== EVENTS =====
  var attachVariantImageSwap = function () {
    document.querySelectorAll('.bundle-variant-select').forEach(function (select) {
      if (select.dataset.listenerAttached) return;
      select.dataset.listenerAttached = 'true';
      select.addEventListener('change', function () {
        var card = select.closest('.bundle-product-card');
        if (!card) return;
        var handle = card.dataset.productHandle;
        var product = (window.cabauspaceBundlesData || []).reduce(function (found, bundle) {
          if (found) return found;
          var candidates = (bundle.products || []).concat(bundle.mainProduct ? [bundle.mainProduct] : []);
          var withAlternatives = candidates.concat(candidates.reduce(function (alts, p) {
            return alts.concat(Array.isArray(p.alternatives) ? p.alternatives : []);
          }, []));
          return withAlternatives.find(function (p) { return p.handle === handle; });
        }, null);
        if (!product || !Array.isArray(product.images)) return;

        var selectedId = select.value;
        var matchedImage = product.images.find(function (img) {
          return Array.isArray(img.variantIds) && img.variantIds.some(function (id) {
            return String(id) === String(selectedId);
          });
        });
        var mainSrc = matchedImage ? matchedImage.src : (product.images[0] ? product.images[0].src : null);
        var hoverSrc = matchedImage
          ? (product.images.filter(function (img) { return img !== matchedImage; })[0] || {}).src
          : (product.images[1] ? product.images[1].src : null);

        var primaryImg = card.querySelector('.bundle-img-primary');
        var secondaryImg = card.querySelector('.bundle-img-secondary');
        if (primaryImg && mainSrc) primaryImg.src = mainSrc;
        if (secondaryImg) {
          if (hoverSrc) {
            secondaryImg.src = hoverSrc;
            secondaryImg.style.display = '';
          } else {
            secondaryImg.style.display = 'none';
          }
        }
      });
    });
  };

  var collectBundleItems = function (bundleSection) {
    var items = [];
    bundleSection.querySelectorAll('.bundle-product-card').forEach(function (card) {
      var select = card.querySelector('.bundle-variant-select');
      var variantId = select ? select.value : card.dataset.defaultVariantId;
      if (!variantId) return;
      items.push({ variantId: variantId, quantity: 1, productId: card.dataset.productId || null });
    });
    return items;
  };

  var attachAddToCartButtons = function (bundles) {
    document.querySelectorAll('.bundle-add-button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.dataset.bundleIndex, 10);
        var bundle = bundles[index];
        var section = btn.closest('.bundle-section');
        if (!bundle || !section) return;

        var items = collectBundleItems(section);
        if (!items.length) return;

        btn.disabled = true;
        showCartOverlay();

        var pricing = getEffectivePricing(bundle, index);

        addItemsToCart(items)
          .then(function () {
            if (pricing.discountCode) {
              return applyDiscountToCart(pricing.discountCode);
            }
          })
          .catch(function (err) {
            console.error('Bundle add-to-cart failed:', err);
          })
          .then(function () {
            hideCartOverlay();
            btn.disabled = false;
          });
      });
    });
  };

  // ===== FETCH + RENDER =====
  var loadBundles = function () {
    var loadingEl = document.getElementById('cabauspace-bundles-loading');
    var listEl = document.getElementById('cabauspace-bundles-list');
    if (!listEl) return;

    fetch(CABAUSPACE_API_BASE_URL + '/api/bundles', {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Backend error');
        return response.json();
      })
      .then(function (json) {
        var bundles = Array.isArray(json.bundles) ? json.bundles : [];
        window.cabauspaceBundlesData = bundles;

        if (!bundles.length) {
          listEl.innerHTML = '<p class="bundles-error">Er zijn momenteel geen bundels beschikbaar.</p>';
        } else {
          var mainCardsHtml = bundles.map(renderMainProductCard).join('');
          listEl.innerHTML =
            '<div class="bundle-products-carousel" id="cabauspace-bundle-main-products-carousel">' + mainCardsHtml + '</div>' +
            '<div id="cabauspace-bundle-detail-container"></div>' +
            '<img id="cabauspace-bundles-filler-image" src="' + BUNDLES_FILLER_IMAGE_URL + '" alt="" />';
          attachVariantImageSwap();
          attachMainProductClickHandlers(bundles);
        }

        if (loadingEl) loadingEl.style.display = 'none';
        listEl.style.display = 'flex';
      })
      .catch(function (err) {
        console.error('Error loading bundles:', err);
        if (loadingEl) loadingEl.style.display = 'none';
        listEl.style.display = 'flex';
        listEl.innerHTML = '<p class="bundles-error">Er ging iets mis bij het laden van de bundels.</p>';
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadBundles);
  } else {
    loadBundles();
  }
})();
